import { render } from "./InstagramIcon.vue?vue&type=template&id=560546a9&scoped=true"
import script from "./InstagramIcon.vue?vue&type=script&lang=js"
export * from "./InstagramIcon.vue?vue&type=script&lang=js"

import "./InstagramIcon.vue?vue&type=style&index=0&id=560546a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560546a9"]])

export default __exports__